import styled from 'styled-components'

import { StyledContactForm } from 'modules/contactForm/ContactForm.styles'

export const StyledWithdrawContactForm = {
  ...StyledContactForm,
  FormInputsWrapper: styled.div`
    input {
      font-size: 16px;
    }
  `,
}
